
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.714 27.429H10.286A2.286 2.286 0 008 29.714V32a2.286 2.286 0 002.286 2.286h27.428A2.286 2.286 0 0040 32v-2.286a2.286 2.286 0 00-2.286-2.285zm0-13.715H10.286A2.286 2.286 0 008 16v2.286a2.286 2.286 0 002.286 2.285h27.428A2.286 2.286 0 0040 18.286V16a2.286 2.286 0 00-2.286-2.286z","fill":"#535353"}})])
          )
        }
      }
    